module.exports = __webpack_public_path__ + "static/img/img_start_4.f02375d.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/img_start_4.png
// module id = zep2
// module chunks = 1